var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseInsights',{attrs:{"compute-function":this.computeGearRatio,"computation-name":"gear ratio"}})}
var staticRenderFns = []

export { render, staticRenderFns }